import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import MyPage from "works/higurashi/pages/MyPage";
import Tickets from "works/higurashi/pages/Tickets";
import Quests from "works/higurashi/pages/Quests";
import HowToUse from "works/higurashi/pages/HowToUse";
import { PrivacyPolicy } from "works/higurashi/pages/LegalDocument";
import Hints from "works/higurashi/pages/Hints";
import News from "works/higurashi/pages/News";
import EmailSettings from "works/higurashi/pages/EmailSettings";
import { getGuidelinesUrl, termsOfServiceUrls } from "constants/links";

import PayPayPolling from "works/higurashi/pages/PayPayPolling";
import PayPayCheck from "works/higurashi/pages/PayPayCheck";

function TermsRedirect() {
  useEffect(() => {
    window.location.replace(termsOfServiceUrls.ja);
  }, []);

  return null;
}

function GuidelinesRedirect() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lng = params.get("lng") || "ja";
    window.location.replace(getGuidelinesUrl("higurashi", lng));
  }, [location.search]);

  return null;
}

export default function HigurashiRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/hints" element={<Hints />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/rules" element={<HowToUse />} />
      <Route path="/guidelines" element={<GuidelinesRedirect />} />
      <Route path="/terms" element={<TermsRedirect />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/news" element={<News />} />
      <Route path="/email-settings" element={<EmailSettings />} />

      <Route path="/paypay/polling" element={<PayPayPolling />} />
      <Route path="/paypay/check" element={<PayPayCheck />} />
    </Routes>
  );
}
